export * from './version';

export const envConstOpts = {
  apiTimeoutInit: 3000,
  apiTimeoutRequest: 300_000, // 5 min, most browsers default value.
  campaignPollInterval: 10_000,
  streamPrice: [[0.005, 'USD'], [0.004, 'EUR']],
  coriteFee: 0.05,
};
